import { render, staticRenderFns } from "./card-primary.vue?vue&type=template&id=2555a23d&scoped=true&"
import script from "./card-primary.vue?vue&type=script&lang=js&"
export * from "./card-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555a23d",
  null
  
)

export default component.exports